var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M0 14.635 1.457 16 10 8 1.457 0 0 1.365 7.085 8z"
})));
export default SvgArrowRight;